import React from "react";
import { Navigate, Route } from "react-router";
import { all_routes } from "./all_routes";
import DataTable from "../components/features/dashboard/employee-dashboard";
import BasicTable from "../components/features/dashboard/employee-dashboard";
import Error404 from "../components/shared/error/error-404";
import Error500 from "../components/shared/error/error-500";

import AdminDashboard from "../components/features/dashboard/index";

import Login2 from "../components/features/auth/login/login-2";
import Login3 from "../components/features/auth/login/login-3";
import ResetPassword2 from "../components/features/auth/resetPassword/resetPassword-2";
import TwoStepVerification2 from "../components/features/auth/twoStepVerification/twoStepVerification-2";
import ForgotPassword2 from "../components/features/auth/forgotPassword/forgotPassword-2";
import ResetPasswordSuccess2 from "../components/features/auth/resetPasswordSuccess/resetPasswordSuccess-2";

import Profile from "../components/features/profile";
import EmployeeDashboard from "../components/features/dashboard/employee-dashboard";
import AttendanceReport from "../components/features/reports/attendance-report";

import EmployeeList from "../components/features/employees/employeesList";
import DeviceConflictLogsAdmin from "../components/features/employees/DeviceConflictLogsAdmin";
import Department from "../components/features/employees/deparment";

import Branch from "../components/features/branch/branch";
import LeaveEmployee2 from "../components/features/leaves/pages/leaveEmployee2";
import LeaveAdmin2 from "../components/features/leaves/pages/leaveAdmin2";
import EmployeeDetails from "../components/features/employees/employeedetails";
import TicketsAdmin from "../components/features/tickets/ticketsAdmin";
import TicketsEmployee from "../components/features/tickets/ticketsEmployee";
import Shift from "../components/features/shift/shift";
import BreakReport from "../components/features/reports/breakReport";
import AttendanceReports from "../components/features/reports/attendanceReport";
import CompanySettings from "../components/features/settings/CompanySettings";
import EmployeeReport from "../components/features/reports/employee-report";
import LeaveReport from "../components/features/reports/leave-report";
import ShiftReport from "../components/features/reports/shift-report";
import TicketReport from "../components/features/reports/ticket-report";
import TimesheetReport from "../components/features/reports/timesheetReport";
import PayrollReport from "../components/features/reports/PayrollReport";
import Notification from "../components/features/notification/notification";
import AllAttendanceUser from "../components/features/employees/components/allEmployeePage/allAttendanceUse";
import AllLeaveUser from "../components/features/employees/components/allEmployeePage/allLeaveUser";
import AllTicketsUser from "../components/features/employees/components/allEmployeePage/allTicketsUser";
import AllNotification from "../components/features/notification/allNotification";
import CompanyDetails from "../components/features/superadmin/companyDetails";
import CreateCompany from "../components/features/superadmin/createCompany";
import AllCompanies from "../components/features/superadmin/allCompanies";
import { PermissionType } from "../types/user.types";
import AboutUs from "../components/features/superadmin/aboutUs";
import EditCompany from "../components/features/superadmin/editCompany";
import SuperAdminDashboard from "../components/features/superadmin/superAdminDashboard";
import AllBreakUser from "../components/features/employees/components/allEmployeePage/allBreakUser";
import ForgottenCheckouts from "../components/features/employees/forgottenCheckouts";
import ForgottenCheckIn from "../components/features/employees/forgottenCheckIn";
import PricingPage from "../components/features/pricing/pricing";
import CouponsPage from "../components/features/superadmin/coupon/coupons";
import CreateCouponPage from "../components/features/superadmin/coupon/createCoupon";
import EditCouponPage from "../components/features/superadmin/coupon/editCoupon";
import CouponDetailsPage from "../components/features/superadmin/coupon/couponDetails";
import PaymentReportsPage from "../components/features/superadmin/paymentReports";
import ProductManagement from "../components/features/superadmin/ProductManagement";
import ParasutInvoices from "../components/features/superadmin/parasut/ParasutInvoices";
//PaymentCallback silindi - sadece SubscriptionCallback kullanılıyor
import SubscriptionCallback from "../components/features/subscription/SubscriptionCallback";
import PaymentCallback from "../components/features/subscription/PaymentCallback";
import DocumentsPage from "../components/features/reports/documents";
import CompanyReport from "../components/features/reports/companyPaymentReport";
import AssetsPage from "../components/features/assets/assets";
import MealsPage from "../components/features/meals/meals";
import MealCalendar from "../components/features/meals/components/MealCalendar";
import SuperAdminBroadcast from "../components/features/superadmin/SuperAdminBroadcast";
import SuperAdminUsers from "../components/features/superadmin/SuperAdminUsers";
import DeviceConflictLogs from "../components/features/superadmin/DeviceConflictLogs";
import PersonelSelectionPage from "../components/features/field-management/PersonelSelectionPage";
import PersonelActivityDetailPage from "../components/features/field-management/PersonelActivityDetailPage";
import VehiclesPage from "../components/features/field-management/vehicles";
import ActivityRequestsPage from "../components/features/field-management/ActivityRequestsPage";
import SMSCallback from "../components/features/subscription/SMSCallback";
import ReferralProgram from "../components/features/referral/ReferralProgram";
import CampaignList from "../components/features/superadmin/referral/CampaignList";
import CampaignForm from "../components/features/superadmin/referral/CampaignForm";
import CampaignDetails from "../components/features/superadmin/referral/CampaignDetails";
import OvertimeManagement from "../components/features/overtime/OvertimeManagement";
import FieldModeRequestsPage from "../components/features/fieldModeRequests/FieldModeRequestsPage";
import ApprovalsPage from "../components/features/approvals/ApprovalsPage";
import MyNotificationsPage from "../components/features/notification/MyNotificationsPage";
const routes = all_routes;

export const publicRoutes = [
  {
    path: "/",
    name: "Root",
    element: <Navigate to="/index" />,
    route: Route,
  },
  // === SÜPER ADMİN ROUTES ===
  {
    path: routes.superAdminDashboard2,
    element: <SuperAdminDashboard />,
    route: Route,
    roles: [PermissionType.SUPER_ADMIN_DASHBOARD],
  },
  {
    path: routes.superAdminCompanies,
    element: <AllCompanies />,
    route: Route,
    roles: [PermissionType.SUPER_ADMIN_VIEW_COMPANIES],
  },
  {
    path: routes.superAdminCompanyDetails,
    element: <CompanyDetails />,
    route: Route,
    roles: [PermissionType.SUPER_ADMIN_VIEW_COMPANIES, PermissionType.SUPER_ADMIN_EDIT_COMPANY],
  },
  {
    path: routes.superAdminCompanyCreate,
    element: <CreateCompany />,
    route: Route,
    roles: [PermissionType.SUPER_ADMIN_CREATE_COMPANY],
  },
  {
    path: routes.superAdminCompanyEdit,
    element: <EditCompany />,
    route: Route,
    roles: [PermissionType.SUPER_ADMIN_EDIT_COMPANY],
  },
  {
    path: routes.superAdminAboutUs,
    element: <AboutUs />,
    route: Route,
    roles: [PermissionType.SUPER_ADMIN_SYSTEM_SETTINGS],
  },
  {
    path: routes.superAdminReferralCampaigns,
    element: <CampaignList />,
    route: Route,
    roles: [PermissionType.SUPER_ADMIN_MANAGE_REFERRAL_CAMPAIGNS],
  },
  {
    path: routes.superAdminReferralCampaignCreate,
    element: <CampaignForm />,
    route: Route,
    roles: [PermissionType.SUPER_ADMIN_MANAGE_REFERRAL_CAMPAIGNS],
  },
  {
    path: routes.superAdminReferralCampaignEdit,
    element: <CampaignForm />,
    route: Route,
    roles: [PermissionType.SUPER_ADMIN_MANAGE_REFERRAL_CAMPAIGNS],
  },
  {
    path: routes.superAdminReferralCampaignDetails,
    element: <CampaignDetails />,
    route: Route,
    roles: [PermissionType.SUPER_ADMIN_MANAGE_REFERRAL_CAMPAIGNS],
  },
  {
    path: routes.adminDashboard,
    element: <AdminDashboard />,
    route: Route,
    roles: [PermissionType.CONTROL_PANEL_ADMIN],
  },
  // {
  //   path: routes.employeeDashboard,
  //   element: <EmployeeDashboard />,
  //   route: Route,
  //   roles: [PermissionType.CONTROL_PANEL_USER],
  // },
  {
    path: routes.branches,
    element: <Branch />,
    roles: [PermissionType.VIEW_BRANCHES],
  },
  {
    path: routes.shift,
    element: <Shift />,
    roles: [PermissionType.MANAGE_SHIFTS],
  },
  {
    path: routes.forgotCheckOut,
    element: <ForgottenCheckouts />,
    roles: [PermissionType.VIEW_REPORTS],
  },
  {
    path: routes.forgotCheckIn,
    element: <ForgottenCheckIn />,
    roles: [PermissionType.VIEW_REPORTS],
  },
  {
    path: routes.attendanceReport,
    element: <AttendanceReport />,
    roles: [PermissionType.VIEW_REPORTS],
  },
  {
    path: routes.notificationList,
    element: <AllNotification />,
    roles: [PermissionType.CREATE_NOTIFICATIONS],
  },
  {
    path: routes.attendance,
    element: <AttendanceReports />,
    roles: [PermissionType.VIEW_REPORTS],
  },
  {
    path: routes.breakReport,
    element: <BreakReport />,
    roles: [PermissionType.VIEW_REPORTS],
  },
  {
    path: routes.companySettings,
    element: <CompanySettings />,
    roles: [PermissionType.COMPANY],
  },
  {
    path: routes.referralProgram,
    element: <ReferralProgram />,
    route: Route,
    roles: [PermissionType.MANAGE_REFERRAL_CAMPAIGNS],
  },
  {
    path: routes.employeeReport,
    element: <EmployeeReport />,
    roles: [PermissionType.VIEW_REPORTS],
  },
  {
    path: routes.shiftReport,
    element: <ShiftReport />,
    roles: [PermissionType.VIEW_REPORTS],
  },
  {
    path: routes.timesheetReport,
    element: <TimesheetReport />,
    roles: [PermissionType.VIEW_COMPANY_TIMESHEET],
  },
  {
    path: routes.ticketReport,
    element: <TicketReport />,
    roles: [PermissionType.VIEW_REPORTS],
  },
  {
    path: routes.notification,
    element: <Notification />,
    roles: [PermissionType.CREATE_NOTIFICATIONS],
  },
  {
    path: routes.userAttendance,
    element: <AllAttendanceUser />,
    roles: [PermissionType.VIEW_USERS],
  },
  {
    path: routes.userBreak,
    element: <AllBreakUser />,
    roles: [PermissionType.VIEW_USERS],
  },
  {
    path: routes.userLeaves,
    element: <AllLeaveUser />,
    roles: [PermissionType.VIEW_LEAVE],
  },
  {
    path: routes.userTickets,
    element: <AllTicketsUser />,
    roles: [PermissionType.VIEW_TICKETS_ADMIN],
  },
  //Application

  {
    path: routes.dataTables,
    element: <DataTable />,
    route: Route,
  },
  {
    path: routes.tablesBasic,
    element: <BasicTable />,
    route: Route,
  },

  {
    path: routes.ticketAdmin,
    element: <TicketsAdmin />,
    route: Route,
    roles: [PermissionType.VIEW_TICKETS_ADMIN],
  },
  {
    path: routes.ticketEmployee,
    element: <TicketsEmployee />,
    route: Route,
    roles: [PermissionType.VIEW_TICKETS_USER],
  },

  {
    path: routes.profile,
    element: <Profile />,
    roles: [
      PermissionType.CONTROL_PANEL_USER,
      PermissionType.CONTROL_PANEL_ADMIN,
      PermissionType.MANAGE_COMPANY
    ],
  },

  {
    path: routes.employeedetails,
    element: <EmployeeDetails />,
    roles: [PermissionType.VIEW_USERS],
  },
  {
    path: routes.leaveReport,
    element: <LeaveReport />,
    roles: [PermissionType.VIEW_REPORTS],
  },
  {
    path: routes.companyReport,
    element: <CompanyReport />,
    roles: [PermissionType.VIEW_COMPANY_PAYMENT],
  },
  {
    path: routes.payrollReport,
    element: <PayrollReport />,
    roles: [PermissionType.VIEW_REPORTS],
  },
  {
    path: routes.companyPaymentHistory,
    element: <CompanyReport />,
    roles: [PermissionType.VIEW_COMPANY_PAYMENT],
  },

  {
    path: routes.employeeList,
    element: <EmployeeList />,
    route: Route,
    roles: [PermissionType.VIEW_USERS],
  },
  {
    path: routes.deviceConflicts,
    element: <DeviceConflictLogsAdmin />,
    route: Route,
    roles: [PermissionType.EDIT_USERS],
  },
  {
    path: routes.departments,
    element: <Department />,
    route: Route,
    roles: [PermissionType.VIEW_DEPARTMENTS],
  },
  {
    path: routes.leaveadmin,
    element: <LeaveAdmin2 />,
    route: Route,
    roles: [PermissionType.VIEW_LEAVE],
  },
  {
    path: routes.leaveemployee,
    element: <LeaveEmployee2 />,
    route: Route,
    roles: [PermissionType.LEAVE_REQUEST],
  },
  // === OVERTIME (FAZLA MESAİ) ROUTES ===
  {
    path: routes.overtimePending,
    element: <OvertimeManagement />,
    route: Route,
    roles: [PermissionType.OVERTIME],
  },
  {
    path: routes.overtimeHistory,
    element: <OvertimeManagement />,
    route: Route,
    roles: [PermissionType.OVERTIME],
  },
  // === FIELD MODE REQUESTS (SAHA MODU TALEPLERİ) ===
  {
    path: routes.fieldModeRequests,
    element: <FieldModeRequestsPage />,
    route: Route,
    roles: [PermissionType.FIELD_MODE_REQUESTS],
  },
  // === ONAYLAR (admin + yönetici; plain user'da CONTROL_PANEL_ADMIN yok) ===
  {
    path: routes.approvals,
    element: <ApprovalsPage />,
    route: Route,
    roles: [PermissionType.CONTROL_PANEL_ADMIN],
  },
  // === BİLDİRİMLERİM (tüm roller: user/manager → CONTROL_PANEL_USER, admin → CONTROL_PANEL_ADMIN, superAdmin → MANAGE_COMPANY) ===
  {
    path: routes.myNotifications,
    element: <MyNotificationsPage />,
    route: Route,
    roles: [
      PermissionType.CONTROL_PANEL_USER,
      PermissionType.CONTROL_PANEL_ADMIN,
      PermissionType.MANAGE_COMPANY,
    ],
  },
  {
    path: routes.employeedetails,
    element: <EmployeeDetails />,
    roles: [PermissionType.VIEW_USERS],
  },
  {
    path: routes.pricing,
    element: <PricingPage />,
    route: Route,
    roles: [PermissionType.PRICING_ACCESS],
  },
  // === KUPON YÖNETİMİ ROUTES ===
  {
    path: routes.coupons,
    element: <CouponsPage />,
    route: Route,
    roles: [PermissionType.SUPER_ADMIN_MANAGE_COUPONS],
  },
  {
    path: routes.createCoupon,
    element: <CreateCouponPage />,
    route: Route,
    roles: [PermissionType.SUPER_ADMIN_MANAGE_COUPONS],
  },
  {
    path: routes.editCoupon,
    element: <EditCouponPage />,
    route: Route,
    roles: [PermissionType.SUPER_ADMIN_MANAGE_COUPONS],
  },
  {
    path: routes.couponDetails,
    element: <CouponDetailsPage />,
    route: Route,
    roles: [PermissionType.SUPER_ADMIN_MANAGE_COUPONS],
  },
  
  // === FİNANSAL YÖNETİM ROUTES ===
  {
    path: routes.paymentReports,
    element: <PaymentReportsPage />,
    route: Route,
    roles: [PermissionType.SUPER_ADMIN_MANAGE_PAYMENTS],
  },
  {
    path: routes.parasutInvoices,
    element: <ParasutInvoices />,
    route: Route,
    roles: [PermissionType.SUPER_ADMIN_VIEW_INVOICES],
  },
  
  // === ÜRÜN YÖNETİMİ ROUTES ===
  {
    path: routes.productManagement,
    element: <ProductManagement />,
    route: Route,
    roles: [PermissionType.SUPER_ADMIN_MANAGE_PRODUCTS],
  },
  {
    path: routes.documents,
    element: <DocumentsPage />,
    route: Route,
    roles: [PermissionType.FILE_VIEW],
  },
  {
    path: routes.subscriptionCallback,
    element: <SubscriptionCallback />,
    route: Route,
    roles: [PermissionType.COMPANY, PermissionType.PRICING_ACCESS],
  },
  // {
  //   path: routes.paymentCallback,
  //   element: <PaymentCallback />,
  //   route: Route,
  //   roles: [PermissionType.COMPANY, PermissionType.PRICING_ACCESS],
  // },
  {
    path: routes.smsCallback,
    element: <SMSCallback />,
    route: Route,
    roles: [PermissionType.COMPANY],
  },
  {
    path: routes.assets,
    element: <AssetsPage />,
    route: Route,
    roles: [PermissionType.VIEW_ASSETS],
  },
  {
    path: routes.meals,
    element: <MealsPage />,
    route: Route,
    roles: [PermissionType.VIEW_MEALS],
  },
  {
    path: routes.mealsList,
    element: <MealsPage />,
    route: Route,
    roles: [PermissionType.VIEW_ASSETS],
  },
  {
    path: routes.mealCalendar,
    element: <MealCalendar />,
    route: Route,
    roles: [PermissionType.VIEW_ASSETS],
  },
  // === İLETİŞİM YÖNETİMİ ROUTES ===
  {
    path: routes.superAdminBroadcast,
    element: <SuperAdminBroadcast />,
    route: Route,
    roles: [PermissionType.SUPER_ADMIN_BROADCAST],
  },
  
  // === KULLANICI YÖNETİMİ ROUTES ===
  {
    path: routes.superAdminUsers,
    element: <SuperAdminUsers />,
    route: Route,
    roles: [PermissionType.SUPER_ADMIN_USER_MANAGEMENT],
  },
  {
    path: routes.superAdminDeviceConflicts,
    element: <DeviceConflictLogs />,
    route: Route,
    roles: [PermissionType.SUPER_ADMIN_USER_MANAGEMENT],
  },
  {
    path: routes.createCompany,
    element: <CreateCompany />,
    route: Route,
    roles: [PermissionType.MANAGE_COMPANY],
  },
  {
    path: routes.personelActivities,
    element: <PersonelSelectionPage />,
    route: Route,
    roles: [PermissionType.VIEW_FIELD_ACTIVITIES]
  },
  {
    path: routes.personelActivitiesUser,
    element: <PersonelActivityDetailPage />,
    route: Route,
    roles: [PermissionType.VIEW_FIELD_ACTIVITIES]
  },
  {
    path: routes.vehicles,
    element: <VehiclesPage />,
    route: Route,
    roles: [PermissionType.VIEW_VEHICLES]
  },
  {
    path: routes.activityRequests,
    element: <ActivityRequestsPage />,
    route: Route,
    roles: [PermissionType.VIEW_FIELD_ACTIVITIES]
  },
];

export const authRoutes = [
  {
    path: routes.login2,
    element: <Login2 />,
    route: Route,
  },
  {
    path: routes.login3,
    element: <Login3 />,
    route: Route,
  },

  {
    path: routes.twoStepVerification2,
    element: <TwoStepVerification2 />,
    route: Route,
  },
  {
    path: routes.resetPassword2,
    element: <ResetPassword2 />,
    route: Route,
  },
  {
    path: routes.paymentCallback,
    element: <PaymentCallback />,
    route: Route,
    // roles: [PermissionType.PRICING_ACCESS] // Ödeme yapabilen herkes callback sayfasını görebilir
  },
  {
    path: routes.forgotPassword2,
    element: <ForgotPassword2 />,
    route: Route,
  },
  {
    path: routes.error404,
    element: <Error404 />,
    route: Route,
  },
  {
    path: routes.error500,
    element: <Error500 />,
    route: Route,
  },
  {
    path: routes.resetPasswordSuccess2,
    element: <ResetPasswordSuccess2 />,
  },

];
